import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const I18nContext = createContext({ lang: "it", t: translations.it, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("maestri_lang") : null;
    if (stored && translations[stored]) return stored;
    if (typeof navigator !== "undefined") {
      const nav = navigator.language?.slice(0, 2);
      if (translations[nav]) return nav;
    }
    return "it";
  });

  useEffect(() => {
    localStorage.setItem("maestri_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
